import { Provider } from '../../../config';
import { EventPayload } from '../../../events';
import ScopeRequestEventPayload from '../../scopeRequest/events/scopeRequestEventPayload';
import ValidationEventBuilder from './ValidationEventBuilder';
import { Validation } from '../../../services/validation';

export type DefaultValidationEvent = {
  provider?: Provider;
  civicPassAuthToken?: string;
  presentationRequestId?: string;
};

/** Build the resulting validation event */
export default class DefaultValidationEventBuilder implements ValidationEventBuilder {
  private provider?: Provider;

  private civicPassAuthToken?: string;

  private presentationRequestId?: string;

  withProvider(provider: Provider): void {
    this.provider = provider;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  withCompletedValidation(_validation: Validation): void {}

  withScopeRequestPayload(scopeRequestPayload?: EventPayload): void {
    if (scopeRequestPayload && scopeRequestPayload instanceof ScopeRequestEventPayload) {
      this.presentationRequestId = scopeRequestPayload?.presentationRequestId;
    }
  }

  withAuthToken(token: string): void {
    this.civicPassAuthToken = token;
  }

  build(): EventPayload {
    return {
      provider: this.provider,
      civicPassAuthToken: this.civicPassAuthToken,
      presentationRequestId: this.presentationRequestId,
    } as DefaultValidationEvent;
  }
}
